module.exports = __webpack_public_path__ + "static/img/product_images_21_h5_zh.5b15817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_21_h5_zh.png
// module id = bK/F
// module chunks = 34